<template>
    <div class="flex min-w-0 items-center gap-2">
        <vx-badge size="xs" :color="runStatusColors[props.run.status]" data-test="run-status">
            {{ runStatusLabels[props.run.status] }}
        </vx-badge>
        <span
            v-if="detail !== null"
            data-test="run-status-detail"
            class="min-w-0 truncate text-xs text-slate-500"
            :title="detail"
        >
            {{ detail }}
        </span>
    </div>
</template>

<script lang="ts" setup>
import { VxBadge } from '@voxie/frontend-components';
import { computed } from 'vue';
import {
    runStatusColors,
    runStatusDetail,
    runStatusLabels,
} from '~/components/kiosk/kiosk-reassigned-numbers/rndLabels';
import type { RndRun } from '~/services/adminRndClient.types';

const props = defineProps<{ run: RndRun }>();

const detail = computed(() => runStatusDetail(props.run));
</script>
